import { render, staticRenderFns } from "./AddComplaint.vue?vue&type=template&id=4039f77b&scoped=true&"
import script from "./AddComplaint.vue?vue&type=script&lang=js&"
export * from "./AddComplaint.vue?vue&type=script&lang=js&"
import style0 from "./AddComplaint.vue?vue&type=style&index=0&id=4039f77b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4039f77b",
  null
  
)

export default component.exports